import type { GetDesignTypesResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { designTypesKeys } from "@/hooks/queryKeys";
import { useUser } from "@/hooks/useUser";
import apiClient from "@/lib/api/client";

export function useSubscriptionPermissions() {
  const { data: userData } = useUser();
  const projectId = userData?.currentProjectId;

  return useQuery({
    enabled: !!userData?.user && !!projectId,
    gcTime: 30 * 60 * 1000, // 30 minutes - permissions don't change frequently
    queryFn: async () => {
      const response = await apiClient
        .url(`/design-types/picker/${projectId}`)
        .get()
        .json<GetDesignTypesResponse>();

      // Transform the response to extract subscription permissions
      const permissions = {
        hasGraphic: true,
        hasVideo: true,
        hasWebsite: true,
      };

      for (const category of response.designTypes.categories) {
        switch (category.id) {
          case "graphic": {
            permissions.hasGraphic = !category.isBlocked;
            break;
          }
          case "video": {
            permissions.hasVideo = !category.isBlocked;
            break;
          }
          case "webui": {
            permissions.hasWebsite = !category.isBlocked;
            break;
          }
        }
      }

      return { permissions };
    },
    queryKey: [
      ...designTypesKeys.picker(projectId ?? undefined),
      "subscription-permissions",
    ],
    staleTime: 15 * 60 * 1000, // 15 minutes - permissions are relatively static
  });
}
